import React from 'react';
import { NavLink } from 'react-router-dom';

export default function LeadDoc() {
  const navLinkClasses = ({ isActive }) =>
    `rounded-lg px-3 py-2 text-sm font-semibold transition ${isActive ? 'bg-purple-600 text-white shadow-md shadow-purple-600/30' : 'text-slate-700 hover:bg-sky-100/80 hover:text-slate-900'}`;

  const glassRootClass = 'relative min-h-screen px-2 pb-8 pt-3 sm:px-4';
  const glassRootStyle = {
    backgroundImage: "linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(192,219,255,0.9) 45%, rgba(179,132,255,0.92) 100%)",
  };
  const glassShellClass = 'rounded-2xl border border-white/50 bg-white/55 shadow-[0_20px_70px_rgba(59,130,246,0.18)] backdrop-blur-xl';
  const glassSectionClass = 'border-b border-white/45 bg-white/45 backdrop-blur-xl';
  const glassCardClass = 'rounded-xl border border-white/50 bg-white/70 p-4 shadow-[0_10px_35px_rgba(76,29,149,0.14)] backdrop-blur';

  const quickStart = [
    'Check credits in the header area. If low, use Buy first.',
    'Open SMTP and run a connection check so sending works before drafting outreach.',
    'Create leads using New Lead Pull (free) or AI pulls if you need broader discovery.',
    'Apply Filter and Companies House Hit to narrow to high-confidence prospects.',
    'Use Enrich on the best candidates before generating scripts or sending email.',
    'Move contacted opportunities forward with Continue to open CRM.',
  ];

  return (
    <div className={glassRootClass} style={glassRootStyle}>
      {/* Navigation Header */}
      <div className="sticky top-0 z-40 rounded-2xl border border-white/50 bg-white/65 shadow-[0_12px_35px_rgba(2,132,199,0.25)] backdrop-blur-xl">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-start gap-3 px-3 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <div className="flex items-center gap-2 sm:gap-3">
            <img src="/avenor.png" alt="InsightOS Avenor Logo" className="h-8 w-8" />
            <h1 className="text-sm font-bold text-slate-900 sm:text-base">InsightOS Avenor Docs</h1>
            <nav className="hidden items-center gap-2 md:flex">
              <NavLink to="/leads" end className={navLinkClasses}>Leads</NavLink>
                <span className="rounded-lg px-3 py-2 text-sm font-semibold text-slate-400">Adverts</span>
                <NavLink to="/leads-docs" className={navLinkClasses}>Docs</NavLink>
            </nav>
          </div>
        </div>
        <div className="border-t border-white/50 px-4 py-2 sm:px-6 md:hidden">
          <nav className="flex items-center gap-2">
            <NavLink to="/leads" end className={navLinkClasses}>Leads</NavLink>
            <span className="rounded-lg px-3 py-2 text-sm font-semibold text-slate-400">Adverts</span>
            <NavLink to="/leads-docs" className={navLinkClasses}>Docs</NavLink>
          </nav>
        </div>
      </div>

      {/* Main Content Area */}
      <div className={`mt-3 w-full overflow-hidden ${glassShellClass}`}>
        <div className={`${glassSectionClass} px-4 py-5 sm:px-6`}>
          <h2 className="text-lg font-bold text-slate-900 sm:text-xl">Leads Training Document</h2>
          <p className="mt-1 text-sm text-slate-700">
            This tutorial explains exactly how to run the Leads workflow end-to-end: setup, lead generation,
            qualification, outreach, reporting, and CRM handoff.
          </p>
        </div>
        
        {/* Video removed per request */}

        {/* Quick Start List Mapping */}
        <div className="space-y-4 px-4 py-5 sm:px-6">
          <section className={glassCardClass}>
            <h3 className="text-base font-semibold text-slate-900">Quick Start (5 Minutes)</h3>
            <ol className="mt-3 list-decimal space-y-2 pl-5 text-sm text-slate-700">
              {quickStart.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ol>
          </section>
        </div>
      </div>
    </div>
  );
}
